/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 29/01/2025 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en sincronización
* ---------------------------------------------------------------------------------------
*/

import {apiKardexArticulos } from "../../settings/ApiConfig";
import { useRequest } from "../../context/System/RequestContext"

import { IconButton, Tooltip } from "@mui/material";
import RestorePageIcon from '@mui/icons-material/RestorePage';
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DirectionsIcon from "@mui/icons-material/Directions";
import VerifiedIcon from "@mui/icons-material/Verified";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from '@mui/icons-material/Print';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import SyncIcon from '@mui/icons-material/Sync';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { Fragment, useEffect, useCallback, useState } from "react";
import { useSesion } from "../../context/System/SesionContext";
import { useInventarios } from "../../context/Inventarios/InventariosContext";
import { isNullOrEmpty } from "../../settings/utils";
import { useDoubleClickPrevention } from "../../hooks/useDoubleClickPrevention";

export default function MnuExistenciasAlmacenesExhibidoresActions({ listaParaSincronizar, almacen, onWhatsApp }) {    
    const {
        handleClickRegresarMainDashboard,
        handleObtenerKardexArticulo,
        handleSincronizarExistenciasFiltradas,
        statusWaiting
    } = useInventarios();

    const { tipoUsuario } = useSesion();

    const { GetRequest } = useRequest();
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    const handleRefresh = ()=>{
    };

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={"Kardex artículo"}>
                <IconButton onClick={handleObtenerKardexArticulo} >
                    <SearchIcon className="icon" /><p className="icon">Kardex</p>
                </IconButton>
            </Tooltip>
            <Tooltip title="Sincronizar existencias filtradas">
                <IconButton 
                    onClick={() => executeWithProtection(() => handleSincronizarExistenciasFiltradas(listaParaSincronizar, almacen))} 
                    disabled={isProcessing || statusWaiting || !listaParaSincronizar || listaParaSincronizar.length === 0}
                >
                    <SyncIcon className="icon" /><p className="icon">Sincronizar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title="Refrescar">
                <IconButton onClick={handleRefresh}>
                    <RefreshIcon className="icon" />
                </IconButton>
            </Tooltip>
            <Tooltip title="Enviar por WhatsApp">
                <span>
                    <IconButton
                        onClick={() => onWhatsApp && executeWithProtection(onWhatsApp)}
                        disabled={isProcessing || !onWhatsApp}
                        sx={{ color: '#25D366' }}
                    >
                        <WhatsAppIcon className="icon" /><p className="icon">WhatsApp</p>
                    </IconButton>
                </span>
            </Tooltip>
        </Fragment>
    );
}
